'use client';

import Script from 'next/script';
import { 
  generateOrganizationSchema, 
  generateWebApplicationSchema 
} from '@/lib/metadata';

/**
 * JSON-LD Structured Data Component
 * Provides machine-readable information about the website
 */
export function StructuredData() {
  const organizationSchema = generateOrganizationSchema();
  const webAppSchema = generateWebApplicationSchema();

  return (
    <>
      {/* Organization Schema */}
      <Script
        id="organization-schema"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(organizationSchema),
        }}
      />
      
      {/* Web Application Schema */}
      <Script
        id="webapp-schema"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(webAppSchema),
        }}
      />
    </>
  );
}
